module.exports = __webpack_public_path__ + "static/img/1-3.9f5ffb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-3.jpg
// module id = jV8f
// module chunks = 25